import styled from 'styled-components';

export const SearchResultContainer = styled.div`
    margin: ${(props) => (props.margin ? props.margin : '0 16px')};
    margin-top: ${(props) => (props.marginTop ? props.marginTop : '35px')};
    font-family: AvenirNextWorld Regular;

    & span {
        font-family: AvenirNextWorld Demi;
    }
`;
